import React from 'react'
import ClinicName from './ClinicName.jsx'
import ClinicAddress from './ClinicAddress.jsx'
import ClinicContactInfo from './ClinicContactInfo.jsx'
import { generateClinicLink, openLink } from '../ResultsList/resultsUtils.js'
import './ClinicCard.scss'

const locale = document.documentElement.lang || 'en'

/*
 * A summary of a clinic, that appears on the index (search results) page. I.e. it's not the
 * details.
 */
const ClinicCard = ({
  cardRef = null,
  clinic,
  clinicNum,

  onMouseEnter,
  onMouseLeave,

  isSelected,
  isCondensedMobileMapView,
  isDesktopHovering,

  lexicon,
}) => {
  const onClickHandler = (event) => {
    const searchParams = window.location.search
    openLink(generateClinicLink(clinic.id, locale, searchParams), event)
  }

  const clinicPrivateText =
    locale === 'es'
      ? clinic.address_private_text_es
      : clinic.address_private_text

  let additionalClasses = ''
  if (isSelected) additionalClasses += 'selected '
  if (isCondensedMobileMapView) additionalClasses += 'condensed '
  if (isDesktopHovering) additionalClasses += 'desktop-hovering '

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={`ClinicCard ${additionalClasses}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClickHandler}
      ref={cardRef}
    >
      <div className="clinic-summary-container">
        <h4 className="miles-away">
          {lexicon.get('miles_away', {
            distance: parseFloat(clinic.miles_from_query_location).toFixed(1),
          })}
        </h4>

        <ClinicName clinicNum={clinicNum} name={clinic.formatted_name} />

        <ClinicAddress
          clinic={clinic}
          privateText={
            clinicPrivateText || lexicon.get('address_private_default')
          }
        />

        <ClinicContactInfo
          clinic={clinic}
          visitWebsiteText={lexicon.get('visit_website')}
        />

        <div className="section-divider" />

        <div className="view-details" tabIndex="0" role="link">
          {lexicon.get('view_details')}
        </div>
      </div>
    </div>
  )
}

export default ClinicCard
